// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthButton__container___3rbdA","left_container":"AuthButton__left_container___1z7rY"};